export const MODAL = {
  ERROR: 'error',
  AUTH: 'auth',
  HIGHLIGHTS: 'highlights'
}
